import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';

import {
  AppTypeCodes,
  OnboardingSetStatusDto,
} from '../interfaces/onboarding.interface';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  constructor(private http: HttpClient) {}

  getOnboardingStatus(
    appTypeCode: keyof typeof AppTypeCodes
  ): Observable<number> {
    return this.http
      .get<number>(`/v1/dbp/business-onboarding?appTypeCode=${appTypeCode}`, {
        observe: 'response',
      })
      .pipe(map((res) => res.body));
  }

  setOnboardingStatus(data: OnboardingSetStatusDto): Observable<any> {
    return this.http.post('/v1/dbp/business-onboarding', data).pipe(
      map((res) => {
        return res;
      })
    );
  }
}
